import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";
import { Card, Spinner, StatusBadge } from "@/components/ui-kit";
import { AffiliateBadge } from "@/components/AffiliateCard";
import { EmptyState } from "@/components/dashboard-bits";
import { Info, ChevronRight, MessageSquare } from "lucide-react";

export default function CreatorApplications() {
  const [apps, setApps] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/applications/mine").then((r) => setApps(r.data)); }, []);

  if (!apps) return <Spinner />;

  return (
    <div data-testid="creator-applications-page">
      <h3 className="text-2xl font-semibold tracking-display text-[#292827] mb-6">Omat hakemukset</h3>

      <div className="mb-6 flex gap-3 rounded-2xl bg-[#E9EAEC] border border-[#E6E1D9] px-5 py-4" data-testid="creator-applications-info">
        <Info size={18} className="text-[#292827] shrink-0 mt-0.5" strokeWidth={1.75} />
        <p className="text-sm text-[#3A3733] leading-relaxed">
          Kun yritys kiinnostuu hakemuksestasi, se ottaa sinuun yhteyttä Creatorin kautta. Muistathan seurata viestejäsi. Yhteistyön lopulliset ehdot, sopimukset ja laskutuksen sovitte keskenänne. Creatori toimii yhteistyökumppaneiden löytämisen alustana.
        </p>
      </div>

      {apps.length === 0 ? (
        <EmptyState title="Et ole vielä hakenut kampanjoihin" subtitle="Selaa kampanjoita ja lähetä hakemus." />
      ) : (
        <div className="space-y-4">
          {apps.map((a) => (
            <Card key={a.application_id}
              onClick={() => navigate(`/dashboard/hakemukset/${a.application_id}`)}
              data-testid="application-card"
              className="p-6 cursor-pointer transition-[transform,box-shadow] duration-300 ease-out hover:soft-shadow-hover hover:-translate-y-0.5">
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  {a.campaign_kind === "affiliate" && <div className="mb-2 flex items-center gap-2" data-testid="creator-affiliate-app"><AffiliateBadge c={a} /><StatusBadge status={a.status} /></div>}
                  <div className="group inline-flex items-center gap-1.5 text-left font-semibold text-[#292827] tracking-tightish">
                    {a.campaign_title}
                    <ChevronRight size={16} className="text-[#968F85] group-hover:text-[#292827] transition-colors" />
                  </div>
                  <p className="mt-1 text-sm text-[#968F85]">Haettu {a.created_at?.slice(0, 10)}</p>
                  <p className="mt-3 text-sm text-[#6E675C] leading-relaxed line-clamp-3">{a.message}</p>
                  {(a.expected_price || a.delivery_time) && (
                    <div className="mt-3 flex flex-wrap gap-2 text-xs">
                      {a.expected_price && <span className="rounded-full border border-[#E6E1D9] px-2.5 py-1 text-[#292827]">Hintapyyntö: {a.expected_price}</span>}
                      {a.delivery_time && <span className="rounded-full border border-[#E6E1D9] px-2.5 py-1 text-[#292827]">Toimitus: {a.delivery_time}</span>}
                    </div>
                  )}
                  <span className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-medium text-[#292827]" data-testid="open-application-conversation">
                    <MessageSquare size={14} strokeWidth={1.75} /> Näytä hakemus ja keskustelu
                  </span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
